<template>
  <v-container fill-height fluid style="flex-wrap: wrap">
    <v-flex md12>
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/a-hidden-trap-in-DNS/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline"> A hidden trap in DNS<br>(DNSに潜む罠) </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://www.slideshare.net/ssuser3c450f/ss-90534970"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline"> エンジニアの会計 </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/accounting-for-engineers/export/index"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline"> Accounting for engineers </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/what-i-got-from-writing-an-english-diary-for-5-months/slides/"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      英語で日記を5ヵ月書き続けて得られたもの
                    </span>
                    <p>※「5ヶ月」は、スライド発表時の継続期間です</p>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/slave-of-OOP/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      「Vue.js
                      分からーん！」と感じていたのは、自分が『オブジェクト指向の奴隷』だったんだと気がついた話。
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/leaning-english-with-smart-speaker/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      スマートスピーカーを英語学習に活用してみる
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/lets-use-PHP-easily/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline"> お手軽に使う PHP </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/logistic-for-engineers-ja/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      物流と在庫管理のシステムについて語りたい
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/my-method-of-organizing-information/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline"> 俺式情報整理術 </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/tough-world-for-windows-user/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      Windowsユーザに厳しいWebの世界
                      ～ほとんどのエンジニアには解けるが、下位10％のダメなエンジニアにだけ解けないパズル？～
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/lets-try-dotnet-application-with-appharbor-for-free/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      AppHarborを使って、.NETアプリを無料デプロイ！
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/slides/lets-try-asterisk/export/index.html"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      【倉庫内無線LAN環境】アンドロイド端末で無料通話をしてみよう
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://kakisoft.github.io/markdown_slide_revealjs/slides/"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      マークダウンでスライドを作ろう！（reveal.js 編）
                    </span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://gitpitch.com/kakisoft/HowToUseGitPitch"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      GitHubだけで作成するスライド「GitPitch」の使い方
                      ～基本編～
                    </span>
                    <br>
                    <br>
                    <span>※GitPitch は 2021年3月にサービスが終了したため、現在このスライドは閲覧できません</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />

      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <v-card
            target="_blank"
            href="https://gitpitch.com/kakisoft/HowToUseGitPitch3"
          >
            <v-img
              :src="require('@/../public/img/black02.png')"
              class="white--text"
              height="200px"
            >
              <v-container fill-height fluid>
                <v-layout fill-height>
                  <v-flex xs12 align-end flexbox>
                    <span class="headline">
                      GitHubだけで作成するスライド「GitPitch」の使い方
                      ～応用編～
                    </span>
                    <br>
                    <br>
                    <span>※GitPitch は 2021年3月にサービスが終了したため、現在このスライドは閲覧できません</span>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <br />
    </v-flex>

    <!-- <v-layout
      justify-center
      align-center
    >

      <v-flex xs12>
        <material-card
          color="green"
          title="Material Dashboard Heading"
          text="Created using Roboto Font Family"
        >
          <v-card-text>
            <h2 class="font-weight-light mb-4">Typography</h2>

            <v-container
              class="pa-0"
              grid-list-xl
              fluid
            >
              <v-layout
                v-for="(t, i) in typography"
                :key="i"
                align-end
                wrap
              >
                <v-flex
                  xs1
                  md3>
                  <span
                    class="tim-note"
                    v-text="t[0]"
                  />
                </v-flex>
                <v-flex xs8>
                  <component
                    :is="t[2]"
                    :class="i"
                  >
                    <template v-if="i !== 'quote'">
                      {{ t[1] }}
                    </template>

                    <p v-if="i === 'quote'">{{ t[1] }}</p>
                    <small v-if="i === 'quote'">Kanye West, Musician</small>

                    <template v-if="i === 'small'">
                      <br>
                      <small>Use 'small' tag for the headers</small>
                    </template>
                  </component>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout> -->
  </v-container>
</template>

<script>
const leader =
  "I will be the leader of a company that ends up being worth billions of dollars, because I got the answers. I understand culture. I am the nucleus. I think that’s a responsibility that I have, to push possibilities, to show people, this is the level that things could be at.";
const leaderShort = leader.slice(0, 105) + "...";
const material = "The Life of Material Dashboard";
const small = "Header with small subtitle";

export default {
  data: () => ({
    typography: {
      "heading-1": ["Header 1", material, "h1"],
      "heading-2": ["Header 2", material, "h2"],
      "heading-3": ["Header 3", material, "h3"],
      "heading-4": ["Header 4", material, "h4"],
      "heading-5": ["Header 5", material, "h5"],
      "heading-6 text-uppercase": ["Header 6", material, "h6"],
      "": ["Paragraph", leader, "p"],
      quote: ["Quote", leader, "blockquote"],
      "text--disabled": ["Muted Text", leaderShort, "p"],
      "text-primary": ["Primary Text", leaderShort, "p"],
      "text-info": ["Info Text", leaderShort, "p"],
      "text-success": ["Success Text", leaderShort, "p"],
      "text-warning": ["Warning Text", leaderShort, "p"],
      "text-danger": ["Danger Text", leaderShort, "p"],
      small: ["Small Tag", small, "h2"],
    },
  }),
};
</script>

<style lang="scss">
.tim-note {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  width: 260px;
}
</style>
